export type EmployeePrimaryKind = 'pos' | 'cash' | 'orders';

export type EmployeePrimaryAction = {
  kind: EmployeePrimaryKind;
  label: string;
  route: 'POS' | 'CashManagement' | 'OrdersInbox';
};

export type EmployeeReadyCardVm = {
  title: string;
  body: string;
  primary: EmployeePrimaryAction | null;
};

/** Copy + CTA del card de empleado en Inicio (proto 1.7). */
export function resolveEmployeeReadyCardVm(input: {
  branchName: string;
  posCanView: boolean;
  cashCanView: boolean;
  ordersCanView: boolean;
}): EmployeeReadyCardVm {
  const branch = input.branchName;

  if (input.posCanView) {
    return {
      title: 'Listo para cobrar',
      body: `Estás en ${branch}. El dueño te habilitó el mostrador.`,
      primary: { kind: 'pos', label: 'Ir a cobrar', route: 'POS' },
    };
  }

  if (input.cashCanView) {
    return {
      title: 'Listo para la caja',
      body: `Estás en ${branch}. Podés ver el turno y movimientos de caja.`,
      primary: { kind: 'cash', label: 'Ver caja', route: 'CashManagement' },
    };
  }

  if (input.ordersCanView) {
    return {
      title: 'Pedidos del local',
      body: `Estás en ${branch}. Revisá los pedidos que entraron.`,
      primary: { kind: 'orders', label: 'Ver pedidos', route: 'OrdersInbox' },
    };
  }

  return {
    title: 'Ya estás en el local',
    body: `Estás en ${branch}. Todavía no tenés permiso para cobrar. Pedile al dueño que te habilite POS o Caja.`,
    primary: null,
  };
}
